import {
  getExportForwardedSifarishUser,
  getExportReportedSifarishUser,
  getExportSavedSifarishUser,
  getUserSifarishDetails,
} from "_services";
import { ButtonHeading } from "components";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Images } from "constants";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { utils } from "helper";
import { AddSifarishModal } from "modals";

const SifarishDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { listData, currentIndexx } = location.state || {};
  const [activeIndex, setActiveIndex] = useState(currentIndexx ?? 0);
  const [sifarishDetails, setSifarishDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const [userData, setUserData] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [isOpen, setIsOpen] = useState(false);
  const [sifarishToEdit, setSifarishToEdit] = useState(null);
  const [allSifarishToEdit, setAllSifarishToEdit] = useState([]);
  const [sifarishInd, setSifarishInd] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      setUserData(JSON.parse(storedUser));
    }
  }, []);

  const userId = userData?._id;
  const sifarishId = searchParams.get("sifarishId");

  useEffect(() => {
    if (!userId) return;
    if (listData && listData.length > 0) return;

    if (sifarishId) {
      fetchSifarishDetails(sifarishId);
    }
  }, [userId, sifarishId]);

  useEffect(() => {
    if (!userId) return;
    if (!listData || !listData[activeIndex]) return;

    const newSifarishId = listData[activeIndex]._id;

    navigate(
      `/sifarish/getSifarishes?userId=${userId}&sifarishId=${newSifarishId}`,
      {
        replace: true,
        state: { listData, currentIndexx: activeIndex },
      }
    );

    fetchSifarishDetails(newSifarishId);
  }, [activeIndex, userId]);

  const fetchSifarishDetails = async (sifarishIdParam) => {
    setLoading(true);
    setError(null);
    const controller = new AbortController();
    const signal = controller.signal;

    try {
      // const payload = { userId, sifarishId };
      const payload = {
        userId,
        sifarishId: sifarishIdParam || sifarishId,
      };
      const res = await getUserSifarishDetails(payload, { signal });

      if (res?.data?.sifarish) {
        setSifarishDetails(res.data.sifarish);
      } else {
        throw new Error(res?.responseMessage || "No data found");
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        setError(error.message || "Something went wrong");
        toast.error(error.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }

    return () => controller.abort();
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: true,
  };

  const exportSavedSifarishToCSV = async () => {
    try {
      const payload = {
        userId: userId,
        sifarishId: sifarishId,
        page: 1,
        limit: -1,
      };

      const res = await getExportSavedSifarishUser(payload);

      if (!res || !res.data?.users || res.data.users.length === 0) {
        toast.error("No data to export!");
        return;
      }

      const fullData = res.data.users;

      const csvHeaders = [
        "Serial No",
        "User",
        "Bird Name",
        "Phone No.",
        "Sifarish Score",
        "Recommended Status",
        "Generation",
        "Location",
      ];

      const csvRows = fullData.map((user, index) => [
        index + 1,
        `"${user?.fromUser?.firstName || "-"} ${
          user?.fromUser?.lastName || "-"
        }"`,
        user?.fromUser?.birdId?.title || "-",
        `"${user?.fromUser?.countryCode || "-"} ${
          user?.fromUser?.phoneNumber || "-"
        }"`,
        user?.fromUser?.sifarishPoints || "-",
        user?.isRecommended === true ? "Recommended" : "Not Recommended",
        user?.fromUser?.generationId?.title || "-",
        `"${user?.fromUser?.city || "-"}, ${user?.fromUser?.state || "-"}, ${
          user?.fromUser?.country || "-"
        }"`,
      ]);

      const csvContent =
        "data:text/csv;charset=utf-8," +
        [csvHeaders.join(","), ...csvRows.map((row) => row.join(","))].join(
          "\n"
        );

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.href = encodedUri;
      const epochTime = Date.now();
      link.download = `Saved_Sifarish_User_${epochTime}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      toast.error(error?.message || "Something went wrong during export.");
    }
  };

  const exportForwardSifarishToCSV = async () => {
    try {
      const payload = {
        userId: userId,
        sifarishId: sifarishId,
        page: 1,
        limit: -1,
      };

      const res = await getExportForwardedSifarishUser(payload);

      if (!res || !res.data?.users || res.data.users.length === 0) {
        toast.error("No data to export!");
        return;
      }

      const fullData = res.data.users;

      const csvHeaders = [
        "Serial No",
        "User",
        "Bird Name",
        "Phone No.",
        "Sifarish Score",
        "Generation",
        "Location",
      ];

      const csvRows = fullData.map((user, index) => [
        index + 1,
        `"${user?.fromUserId?.firstName || "-"} ${
          user?.fromUserId?.lastName || "-"
        }"`,
        user?.fromUserId?.birdId?.title || "-",
        `"${user?.fromUserId?.countryCode || "-"} ${
          user?.fromUserId?.phoneNumber || "-"
        }"`,
        user?.fromUserId?.sifarishPoints || "-",
        user?.fromUserId?.generationId?.title || "-",
        `"${user?.fromUserId?.city || "-"}, ${
          user?.fromUserId?.state || "-"
        }, ${user?.fromUserId?.country || "-"}"`,
      ]);

      const csvContent =
        "data:text/csv;charset=utf-8," +
        [csvHeaders.join(","), ...csvRows.map((row) => row.join(","))].join(
          "\n"
        );

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.href = encodedUri;
      const epochTime = Date.now();
      link.download = `Forwarded_Sifarish_User_${epochTime}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      toast.error(error?.message || "Something went wrong during export.");
    }
  };

  const exportReportedSifarishToCSV = async () => {
    try {
      const payload = {
        userId: userId,
        sifarishId: sifarishId,
        page: 1,
        limit: -1,
      };

      const res = await getExportReportedSifarishUser(payload);

      if (!res || !res.data?.users || res.data.users.length === 0) {
        toast.error("No data to export!");
        return;
      }

      const fullData = res.data.users;

      const csvHeaders = [
        "Serial No",
        "User",
        "Bird Name",
        "Phone No.",
        "Sifarish Score",
        "Generation",
        "Location",
        "Reported Reason",
      ];

      const csvRows = fullData.map((user, index) => [
        index + 1,
        `"${user?.fromUserId?.firstName || "-"} ${
          user?.fromUserId?.lastName || "-"
        }"`,
        user?.fromUserId?.birdId?.title || "-",
        `"${user?.fromUserId?.countryCode || "-"} ${
          user?.fromUserId?.phoneNumber || "-"
        }"`,
        user?.fromUserId?.sifarishPoints || "-",
        user?.fromUserId?.generationId?.title || "-",
        `"${user?.fromUserId?.city || "-"}, ${
          user?.fromUserId?.state || "-"
        }, ${user?.fromUserId?.country || "-"}"`,
        `"${user?.reasonId?.title || "-"}"`,
      ]);

      const csvContent =
        "data:text/csv;charset=utf-8," +
        [csvHeaders.join(","), ...csvRows.map((row) => row.join(","))].join(
          "\n"
        );

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.href = encodedUri;
      const epochTime = Date.now();
      link.download = `Reported_Sifarish_User_${epochTime}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      toast.error(error?.message || "Something went wrong during export.");
    }
  };

  const handleBackButton = () => {
    navigate(-1);
  };

  return (
    <>
      <ButtonHeading
        title="Sifarish Details"
        isShow={{
          isBackButton: true,
        }}
        handleBackButton={() => handleBackButton()}
      />

      <div className="d-flex justify-content-between px-3 mt-3">
        <button
          disabled={activeIndex === 0}
          className="__birdTag"
          onClick={() => setActiveIndex((prev) => prev - 1)}
        >
          ⬅ Previous
        </button>

        <button
          disabled={activeIndex === listData.length - 1}
          className="__birdTag"
          onClick={() => setActiveIndex((prev) => prev + 1)}
        >
          Next ➜
        </button>
      </div>

      <div>
        {loading ? (
          <p>Loading Sifarish Details...</p>
        ) : error ? (
          <p className="text-red-500">Error: {error}</p>
        ) : sifarishDetails ? (
          <>
            <div className="py-4">
              <div className=" __sifarisD_head  mb-3 ">
                <div className="__sifDetail_bxs">
                  <h4>Title: {sifarishDetails?.title || "No Title"}</h4>
                  <p>Description: {sifarishDetails?.description || ""}</p>
                  
                </div>

                <div className="__rSide_btn">
                  <button
                    className="__birdTag "
                    onClick={() => exportSavedSifarishToCSV()}
                  >
                    Export saved sifarish users
                  </button>
                  <button
                    className="__birdTag "
                    onClick={() => exportForwardSifarishToCSV()}
                  >
                    Export forwarded sifarish users
                  </button>
                  <button
                    className="__birdTag "
                    onClick={() => exportReportedSifarishToCSV()}
                  >
                    Export reported sifarish users
                  </button>

                  <button
                    className="__birdTag"
                    onClick={() => {
                      setSifarishToEdit(sifarishDetails);
                      setAllSifarishToEdit(listData || []);
                      setSifarishInd(activeIndex);
                      setIsOpen(true);
                    }}
                  >
                    Edit Sifarish
                  </button>
                </div>
              </div>

              {sifarishDetails?.mediaUrls?.length > 0 ? (
                sifarishDetails?.mediaUrls?.length === 1 ? (
                  <img
                    src={
                      sifarishDetails.mediaUrls[0]?.url ||
                      "https://via.placeholder.com/400x300"
                    }
                    alt={`Sifarish_Media_${sifarishDetails.mediaUrls[0]?._id}`}
                    width={400}
                    height={300}
                    className="_slidImgOne"
                  />
                ) : (
                  <Slider {...sliderSettings} className="__anvSlickSlider">
                    {sifarishDetails?.mediaUrls?.map((item, index) => (
                      <div key={index}>
                        <img
                          onClick={() => {
                            setCurrentIndex(index);
                            setLightboxOpen(true);
                          }}
                          src={
                            item?.url || "https://via.placeholder.com/400x300"
                          }
                          alt={`Sifarish_Media_${item?._id}`}
                          width={400}
                          height={300}
                          className="_slidImg"
                        />
                      </div>
                    ))}
                  </Slider>
                )
              ) : (
                <p className="text-center">No Media Available</p>
              )}
            </div>

            <div className="px-4 pb-4">
              <div className="__userView ">
                <div className="mb-2">
                  <img
                    src={
                      sifarishDetails?.createdByUserId?.userProfileImageUrl ||
                      Images.USERLIMG
                    }
                    alt="user Img"
                    style={{ borderRadius: "50%" }}
                    width={60}
                    height={60}
                  />
                </div>

                <div>
                  <h4>
                    {sifarishDetails?.createdByUserId?.firstName}{" "}
                    {sifarishDetails?.createdByUserId?.lastName}
                  </h4>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <p>{sifarishDetails?.createdByUserId?.phoneNumber} </p>
                </div>

                <div>
                  <p>
                    <b>Category: </b>
                    {sifarishDetails?.categoryId?.title}
                  </p>
                </div>

                <div>
                  <p>
                    <b>Subcategory: </b>

                    {sifarishDetails?.categoryId?.subCategories?.length > 0
                      ? sifarishDetails.categoryId.subCategories
                          .filter(
                            (sub) => sub._id === sifarishDetails.subCategoryId
                          )
                          .map((sub) => <span key={sub._id}>{sub.title}</span>)
                      : "No Subcategory Available"}
                  </p>
                </div>

                <div>
                  <p>
                    <b>Links: </b>
                    {sifarishDetails?.links?.length > 0
                      ? sifarishDetails.links.map((url, index) => (
                          <Link key={url} to={url.url} target="_blank">
                            {url.url}
                            {index !== sifarishDetails.links.length - 1
                              ? ", "
                              : ""}
                          </Link>
                        ))
                      : "No Links Available"}
                  </p>
                </div>

                <div className="__staTics">
                  <h5>Statistics</h5>

                  <div style={{ flex: "0 0 33.33%" }}>
                    <h6>
                      Total Forwarded <IoMdInformationCircleOutline />
                    </h6>
                    <p>{sifarishDetails?.totalForwarded}</p>
                  </div>

                  <div style={{ flex: "0 0 33.33%" }}>
                    <h6>
                      Total Recomended Reviews
                      <IoMdInformationCircleOutline />
                    </h6>
                    <p>{sifarishDetails?.totalRecommendedReviews}</p>
                  </div>

                  <div style={{ flex: "0 0 33.33%" }}>
                    <h6>
                      Total Reviews <IoMdInformationCircleOutline />
                    </h6>
                    <p>{sifarishDetails?.totalReviews}</p>
                  </div>
                </div>
                <div>
                  <p>
                    <b>Created Date: </b>
                    {sifarishDetails?.createdAt
                      ? utils?.formatDateToDDMMYYYY(sifarishDetails?.createdAt)
                      : ""}
                  </p>
                </div>

                <div>
                  <p>
                    <b>Contact Name: </b>
                    {sifarishDetails?.contactName}
                  </p>
                </div>

                <div>
                  <p>
                    <b>Contact Email: </b>
                    {sifarishDetails?.email}
                  </p>
                </div>

                <div>
                  <p>
                    <b>Contact Number: </b>
                    {sifarishDetails?.phoneNumber}
                  </p>
                </div>
              </div>
            </div>
            {lightboxOpen && (
              <div
                className="lightbox-overlay"
                onClick={() => setLightboxOpen(false)}
                onKeyDown={(e) => {
                  if (e.key === "Escape") setLightboxOpen(false);
                  if (e.key === "ArrowLeft")
                    setCurrentIndex((prev) => Math.max(prev - 1, 0));
                  if (e.key === "ArrowRight")
                    setCurrentIndex((prev) =>
                      Math.min(prev + 1, sifarishDetails.mediaUrls.length - 1)
                    );
                }}
                tabIndex={0}
              >
                <div
                  className="lightbox-container"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="lightbox-close"
                    onClick={() => setLightboxOpen(false)}
                  >
                    ✕
                  </button>

                  <Slider {...sliderSettings} initialSlide={currentIndex}>
                    {sifarishDetails.mediaUrls.map((item, index) => (
                      <div key={index} className="">
                        <img
                          src={
                            item?.url || "https://via.placeholder.com/800x600"
                          }
                          alt={`Fullscreen Sifarish Media ${index}`}
                          className="lightbox-image"
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            )}
          </>
        ) : (
          <p>No Sifarish details available.</p>
        )}
      </div>

      {isOpen && (
        <AddSifarishModal
          isOpen={isOpen}
          closeModal={() => setIsOpen(false)}
          modalMainClass="_dashCommon_Modal _lgModal"
          modalTitle={sifarishToEdit ? "Edit Sifarish" : "Add Sifarish"}
          footerPart={true}
          submitTitle={sifarishToEdit ? "Update Sifarish" : "Add Sifarish"}
          setFilter={{}}
          filter={{}}
          userData={userData}
          onSuccess={() => fetchSifarishDetails(sifarishId)}
          sifarishToEdit={sifarishToEdit}
          sifarishArrayToEdit={{ allSifarishToEdit }}
          sifarishInd={sifarishInd}
        />
      )}
    </>
  );
};

export default SifarishDetail;
